module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "margin-left": "3%",
      "margin-right": "3%",
      "max-width": "94%"
    },
    attrs: {
      "editquoteDetails": "",
      "grid-list-xl": ""
    }
  }, [(_vm.spineLoading == true) ? _c('center', [_c('h2', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_vm._v("Loading Articles and Synchronising with Store"), _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "20px",
      "font-size": "12px"
    }
  }, [_vm._v("Please Wait")])])]) : _vm._e(), _vm._v(" "), (_vm.spineLoading == false && _vm.showSpec == false) ? _c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Quote Details")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "disabled": !_vm.fncCanShowSpecDetails(_vm.globalModalParams.details),
      "ripple": ""
    }
  }, [_vm._v("Spec Details")]), _vm._v(" "), (_vm.isTallisman == true) ? _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Delivery Address")]) : _vm._e(), _vm._v(" "), (_vm.isTallisman == true) ? _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Order Notes")]) : _vm._e(), _vm._v(" "), (_vm.isTallisman == true) ? _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Account Details")]) : _vm._e(), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-2 pb-4",
    staticStyle: {
      "margin-left": "0px !important"
    }
  }, [_c('v-container', {
    staticStyle: {
      "max-width": "100% !important",
      "width": "100% !important",
      "margin-left": "0px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "12px",
      "margin-right": "10px"
    }
  }, [_vm._v("ADD LINE ITEM:")]), _vm._v(" "), (this.spineLoading == false && this.loadedDepartment.can_add_rows == 1) ? _c('v-btn', {
    ref: "addButton",
    staticClass: "addproduct text-xs-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddRow()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Article/Product")]) : _vm._e(), _vm._v(" "), (this.spineLoading == false && this.loadedDepartment.can_add_rows == 1 && _vm.isTallisman == true) ? _c('v-btn', {
    staticClass: "addproduct text-xs-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddInstallationTallisman('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Delivery")]) : _vm._e(), _vm._v(" "), (this.spineLoading == false && this.loadedDepartment.can_add_rows == 1 && _vm.isTallisman == true) ? _c('v-btn', {
    staticClass: "addproduct text-xs-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddFuelTallisman()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Fuel ( No VAT )")]) : _vm._e(), _vm._v(" "), (this.spineLoading == false && this.loadedDepartment.can_add_rows == 1 && _vm.isTallisman == true) ? _c('v-btn', {
    staticClass: "addproduct text-xs-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddInstallationTallisman('fuel')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Fuel ( VAT )")]) : _vm._e(), _vm._v(" "), (this.spineLoading == false && this.loadedDepartment.can_add_rows == 1 && _vm.isTallisman == true) ? _c('v-btn', {
    staticClass: "addproduct text-xs-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddInstallationTallisman('consumable')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Consumables")]) : _vm._e(), _vm._v(" "), (_vm.spineLoading == false) ? _c('v-data-table', {
    staticClass: "middleTable minTable editTable quoteEditTable",
    staticStyle: {
      "width": "100%",
      "font-size": "10px"
    },
    attrs: {
      "search": _vm.search,
      "headers": _vm.headers,
      "items": _vm.globalModalParams.details,
      "disable-initial-sort": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return (props.item.deleted == false) ? [_c('tr', {
          class: _vm.fncGetClass(props.item)
        }, [(_vm.fncShowRow('calculator') && _vm.fncNotInstall(props.item) == true) ? _c('td', {
          staticClass: "calculator-field non-input-field"
        }, [(_vm.fncIsCalcDisabled(props.item) == true) ? _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncGetCalcName(props.item.calculator))
          }
        }) : _c('v-select', {
          attrs: {
            "label": "Search",
            "items": _vm.departmentRangesListFiltered,
            "item-value": "id32",
            "item-text": "name",
            "autocomplete": "",
            "solo": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncFilterIndexItems(props.index, props.item.calculator)
            }
          },
          model: {
            value: (props.item.calculator),
            callback: function($$v) {
              _vm.$set(props.item, "calculator", $$v)
            },
            expression: "props.item.calculator"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('calculator') && _vm.fncNotInstall(props.item) == false) ? _c('td', {
          staticClass: "calculator-field non-input-field"
        }) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('location')) ? _c('td', {
          staticClass: "location-field non-input-field"
        }, [_c('v-select', {
          staticClass: "setLocation",
          attrs: {
            "label": "Set Location",
            "items": _vm.fncGetLocations(),
            "item-value": "name",
            "item-text": "name",
            "autocomplete": "",
            "solo": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSetLocation(props.index, props.item)
            }
          },
          model: {
            value: (props.item.location_drop),
            callback: function($$v) {
              _vm.$set(props.item, "location_drop", $$v)
            },
            expression: "props.item.location_drop"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('vendor')) ? _c('td', {
          staticClass: "vendor-field non-input-field",
          domProps: {
            "innerHTML": _vm._s(_vm.fncGetVendor(props.item))
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('articleDescription') && props.item.m2m == true && !_vm.fncIsConsumable(props.item) && !_vm.fncIsFuelVat(props.item) && !_vm.fncIsDelivery(props.item) && props.item.bw_code != '751226' && props.item.bw_code != '000000000000751226' && props.item.bw_code != '751229' && props.item.bw_code != '000000000000751229' && props.item.bw_code != '787515' && props.item.bw_code != '000000000000787515') ? _c('td', {
          staticClass: "articledesc-field non-input-field"
        }, [_c('v-select', {
          staticClass: "filterArticles",
          staticStyle: {
            "margin-bottom": "4px"
          },
          attrs: {
            "label": "Filter Articles By",
            "items": _vm.fncFinalItemsFilteredFilter(props.item.is_install, props.item.calculator),
            "item-value": "id",
            "item-text": "name",
            "autocomplete": "",
            "solo": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSetProductCode(props.index, props.item, props.item.filter)
            }
          },
          model: {
            value: (props.item.filter),
            callback: function($$v) {
              _vm.$set(props.item, "filter", $$v)
            },
            expression: "props.item.filter"
          }
        }), _vm._v(" "), _c('v-select', {
          attrs: {
            "label": "Search",
            "items": _vm.fncFinalItemsFiltered(props.item.is_install, props.item.calculator, true, props.item.filter, props.index),
            "item-value": "article_description",
            "item-text": "article_description_vendor",
            "autocomplete": "",
            "solo": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSetProductCode(props.index, props.item)
            }
          },
          model: {
            value: (props.item.name),
            callback: function($$v) {
              _vm.$set(props.item, "name", $$v)
            },
            expression: "props.item.name"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('articleDescription') && _vm.isTallisman != true && !_vm.fncIsDelivery(props.item) && props.item.m2m == false && props.item.edit_current == true) ? _c('td', {
          staticClass: "articledesc-field non-input-field"
        }, [_c('v-select', {
          staticClass: "filterArticles",
          staticStyle: {
            "margin-bottom": "4px"
          },
          attrs: {
            "label": "Filter Articles By",
            "items": _vm.fncFinalItemsFilteredFilter(props.item.is_install, props.item.calculator),
            "item-value": "id",
            "item-text": "name",
            "autocomplete": "",
            "solo": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSetProductCode(props.index, props.item, props.item.filter)
            }
          },
          model: {
            value: (props.item.filter),
            callback: function($$v) {
              _vm.$set(props.item, "filter", $$v)
            },
            expression: "props.item.filter"
          }
        }), _vm._v(" "), _c('v-select', {
          attrs: {
            "label": "Search",
            "items": _vm.fncFinalItemsFiltered(props.item.is_install, props.item.calculator, false, props.item.filter, props.index),
            "item-value": "article_value",
            "item-text": "article_description_vendor",
            "autocomplete": "",
            "solo": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSetProductCode(props.index, props.item)
            }
          },
          model: {
            value: (props.item.calc_name),
            callback: function($$v) {
              _vm.$set(props.item, "calc_name", $$v)
            },
            expression: "props.item.calc_name"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('articleDescription') && _vm.isTallisman != true && !_vm.fncIsDelivery(props.item) && props.item.m2m == false && (props.item.edit_current == false || props.item.edit_current == undefined)) ? _c('td', {
          staticClass: "articledesc-field non-input-field"
        }, [_vm._v("\n                  " + _vm._s(props.item.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('articleDescription') && !_vm.fncIsConsumable(props.item) && _vm.fncIsDelivery(props.item)) ? _c('td', {
          staticClass: "articledesc-field non-input-field"
        }, [_vm._v("\n                  Delivery\n                ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('articleDescription') && _vm.fncIsConsumable(props.item)) ? _c('td', {
          staticClass: "articledesc-field non-input-field"
        }, [_vm._v("\n                  Consumables\n                ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('articleDescription') && _vm.fncIsFuelVat(props.item)) ? _c('td', {
          staticClass: "articledesc-field non-input-field"
        }, [_vm._v("\n                  Talisman Fuel - VAT\n                ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('articleDescription') && !_vm.fncIsDelivery(props.item) && _vm.isTallisman == true && (props.item.bw_code == '751226' || props.item.bw_code == '000000000000751226' || props.item.bw_code == '751229' || props.item.bw_code == '000000000000751229' || props.item.bw_code == '787515' || props.item.bw_code == '000000000000787515')) ? _c('td', {
          staticClass: "articledesc-field non-input-field"
        }, [_vm._v("\n                  " + _vm._s(props.item.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('articleDescription') && !_vm.fncIsDelivery(props.item) && _vm.isTallisman == true && props.item.added_from_screen == undefined && (props.item.bw_code == '751223' || props.item.bw_code == '706223587' || props.item.bw_code == '000000000000751223' || props.item.bw_code == '000000000706223587')) ? _c('td', {
          staticClass: "articledesc-field non-input-field"
        }, [_vm._v("\n                  " + _vm._s(props.item.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('bwArticleNo') && props.item.m2m == true && props.item.calc_name == '') ? _c('td', {
          staticClass: "article-field non-input-field"
        }, [_c('v-text-field', {
          attrs: {
            "solo": ""
          },
          model: {
            value: (props.item.bw_code),
            callback: function($$v) {
              _vm.$set(props.item, "bw_code", $$v)
            },
            expression: "props.item.bw_code"
          }
        }), _vm._v(" "), (_vm.isTallisman == false && _vm.fncNotInstall(props.item.code) && _vm.installed == false && props.item.bw_code != '' && props.item.bw_code != '000000000000000000' && _vm.canInstall == true && (props.item.is_install == undefined || props.item.is_install == false) && _vm.fncCanInstall(props.index)) ? _c('v-btn', {
          staticClass: "install-btn",
          staticStyle: {
            "display": "block"
          },
          attrs: {
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.fncAddInstallation(props.index)
            }
          }
        }, [_vm._v("Install this product")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('bwArticleNo') && (props.item.m2m == false || props.item.calc_name != '')) ? _c('td', {
          staticClass: "article-field non-input-field"
        }, [_vm._v("\n                  " + _vm._s(parseInt(props.item.bw_code)) + "\n\n                  "), (_vm.isTallisman == false && _vm.fncHasInstall(props.item.is_install) && _vm.fncNotInstall(props.item.code) && _vm.installed == false && props.item.bw_code != '' && props.item.bw_code != '000000000000000000' && _vm.canInstall == true && (props.item.is_install == undefined || props.item.is_install == false) && _vm.fncCanInstall(props.index)) ? _c('v-btn', {
          staticClass: "install-btn",
          staticStyle: {
            "display": "block"
          },
          attrs: {
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.fncAddInstallation(props.index)
            }
          }
        }, [_vm._v("Install this product")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('plantCode') && props.item.bw_code != '787515' && props.item.bw_code != '000000000000787515' && !_vm.fncIsConsumable(props.item) && !_vm.fncIsDelivery(props.item) && !_vm.fncIsFuelVat(props.item) && !_vm.fncIsConsumable(props.item)) ? _c('td', {
          staticClass: "non-input-field"
        }, [_c('v-select', {
          attrs: {
            "label": "Code",
            "items": _vm.fncVendorCodes(props.item.bw_code),
            "item-value": "name",
            "item-text": "name",
            "autocomplete": "",
            "solo": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSetVendorDescription(props.index, props.item.bw_code, props.item.vendor_code)
            }
          },
          model: {
            value: (props.item.vendor_code),
            callback: function($$v) {
              _vm.$set(props.item, "vendor_code", $$v)
            },
            expression: "props.item.vendor_code"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('plantCode') && (props.item.bw_code == '787515' || props.item.bw_code == '000000000000787515')) ? _c('td', {
          staticClass: "non-input-field"
        }, [_vm._v("\n                  Talisman Fuel\n                ")]) : _vm._e(), _vm._v(" "), (_vm.fncCheckCodeDescription(props.item) && _vm.fncShowRow('plantCode') && (props.item.bw_code == '751225' || props.item.bw_code == '000000000000751225')) ? _c('td', {
          staticClass: "non-input-field",
          domProps: {
            "innerHTML": _vm._s(_vm.fncSetCodeDescription(props.item))
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('productDescription') && _vm.isTallisman == false && props.item.m2m == true) ? _c('td', {
          staticClass: "productdesc-field non-input-field"
        }, [_c('v-text-field', {
          attrs: {
            "maxlength": 30,
            "counter": 30,
            "textarea": "",
            "rows": "2",
            "solo": ""
          },
          model: {
            value: (props.item.name_sub),
            callback: function($$v) {
              _vm.$set(props.item, "name_sub", $$v)
            },
            expression: "props.item.name_sub"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('productDescription') && _vm.isTallisman == false && props.item.m2m == false) ? _c('td', {
          staticClass: "productdesc-field non-input-field"
        }, [_vm._v(_vm._s(props.item.name_sub))]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('productDescription') && !_vm.fncIsFuelVat(props.item) && !_vm.fncIsDelivery(props.item) && _vm.isTallisman == true) ? _c('td', {
          staticClass: "productdesc-field non-input-field"
        }, [_c('v-text-field', {
          attrs: {
            "maxlength": 30,
            "counter": 30,
            "textarea": "",
            "rows": "2",
            "solo": ""
          },
          model: {
            value: (props.item.name_sub),
            callback: function($$v) {
              _vm.$set(props.item, "name_sub", $$v)
            },
            expression: "props.item.name_sub"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('productDescription') && !_vm.fncIsConsumable(props.item) && !_vm.fncIsFuelVat(props.item) && _vm.fncIsDelivery(props.item) && _vm.isTallisman == true) ? _c('td', {
          staticClass: "productdesc-field non-input-field"
        }, [_vm._v("Delivery")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('productDescription') && _vm.fncIsFuelVat(props.item) && _vm.isTallisman == true) ? _c('td', {
          staticClass: "productdesc-field non-input-field"
        }, [_vm._v("Fuel Mix – WITH VAT")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('quantity') && _vm.fncInputQty(props.item) == true) ? _c('td', {
          staticClass: "quantity-field non-input-field text-xs-right"
        }, [_c('v-text-field', {
          attrs: {
            "solo": "",
            "single-line": "",
            "type": "number"
          },
          on: {
            "input": function($event) {
              return _vm.fncCanSave(props.index, 'qty')
            }
          },
          model: {
            value: (props.item.quantity),
            callback: function($$v) {
              _vm.$set(props.item, "quantity", $$v)
            },
            expression: "props.item.quantity"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('quantity') && _vm.fncInputQty(props.item) == false) ? _c('td', {
          staticClass: "quantity-field non-input-field text-xs-right"
        }, [_vm._v(_vm._s(props.item.quantity))]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('uom')) ? _c('td', {
          staticClass: "uom-field non-input-field",
          domProps: {
            "innerHTML": _vm._s(_vm.fncFormatUom(props.item))
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('hireDate') && _vm.fncCheckChildRow(props.item)) ? _c('td', {
          staticClass: "hire-field"
        }, [_c('date-picker', {
          staticStyle: {
            "display": "block",
            "float": "left"
          },
          attrs: {
            "format": "YYYY-MM-DD",
            "lang": "en"
          },
          on: {
            "input": function($event) {
              return _vm.fncCheckHireDays(props.index, 'hire_date_start')
            }
          },
          model: {
            value: (props.item.hire_date_start),
            callback: function($$v) {
              _vm.$set(props.item, "hire_date_start", $$v)
            },
            expression: "props.item.hire_date_start"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "padding-left": "10px",
            "padding-right": "10px",
            "padding-top": "10px",
            "display": "block",
            "float": "none !important"
          }
        }, [_vm._v("to")]), _vm._v(" "), _c('date-picker', {
          staticStyle: {
            "display": "block",
            "float": "left"
          },
          attrs: {
            "format": "YYYY-MM-DD",
            "lang": "en"
          },
          on: {
            "input": function($event) {
              return _vm.fncCheckHireDays(props.index, 'hire_date_end')
            }
          },
          model: {
            value: (props.item.hire_date_end),
            callback: function($$v) {
              _vm.$set(props.item, "hire_date_end", $$v)
            },
            expression: "props.item.hire_date_end"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('hireDate') && !_vm.fncCheckChildRow(props.item)) ? _c('td', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('hirePeriod') && _vm.fncCheckChildRow(props.item)) ? _c('td', {
          staticClass: "hirePeriod"
        }, [_c('div', [_c('span', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_vm._v("Day/s:")]), _c('v-text-field', {
          staticStyle: {
            "display": "inline-block",
            "margin": "0",
            "width": "auto !important"
          },
          attrs: {
            "disabled": "",
            "true": "",
            "solo": "",
            "single-line": "",
            "min": _vm.fncHirePeriodMin(props.index),
            "max": _vm.fncHirePeriodMax(props.index),
            "type": "number",
            "step": "0.5"
          },
          on: {
            "input": function($event) {
              return _vm.fncCanSave(props.index)
            }
          },
          model: {
            value: (props.item.hire_period),
            callback: function($$v) {
              _vm.$set(props.item, "hire_period", $$v)
            },
            expression: "props.item.hire_period"
          }
        })], 1), _vm._v(" "), (_vm.fncCanDecrease(props.index)) ? _c('a', {
          staticClass: "remove-half",
          on: {
            "click": function($event) {
              return _vm.fncUpdateDays('descrease', props.index)
            }
          }
        }, [_c('small', [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("remove")]), _vm._v(" half day")])]) : _vm._e(), _vm._v(" "), (_vm.fncCanIncrease(props.index)) ? _c('a', {
          staticClass: "add-half",
          on: {
            "click": function($event) {
              return _vm.fncUpdateDays('increase', props.index)
            }
          }
        }, [_c('small', [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("add")]), _vm._v(" half day")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('hirePeriod') && !_vm.fncCheckChildRow(props.item)) ? _c('td', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('deliveryMethod') && _vm.fncCheckChildRow(props.item)) ? _c('td', {
          staticClass: "text-xs-right centerText"
        }, [_c('v-select', {
          attrs: {
            "label": "Select",
            "items": _vm.collectDeliver,
            "item-value": "name",
            "item-text": "name",
            "autocomplete": "",
            "solo": ""
          },
          model: {
            value: (props.item.delivery_method),
            callback: function($$v) {
              _vm.$set(props.item, "delivery_method", $$v)
            },
            expression: "props.item.delivery_method"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('deliveryMethod') && !_vm.fncCheckChildRow(props.item)) ? _c('td', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('receivalTime') && _vm.fncCheckChildRow(props.item)) ? _c('td', {
          staticClass: "text-xs-right centerText"
        }, [_c('v-select', {
          attrs: {
            "label": "Select",
            "items": _vm.receival,
            "item-value": "name",
            "item-text": "name",
            "autocomplete": "",
            "solo": ""
          },
          model: {
            value: (props.item.receival_time),
            callback: function($$v) {
              _vm.$set(props.item, "receival_time", $$v)
            },
            expression: "props.item.receival_time"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('receivalTime') && !_vm.fncCheckChildRow(props.item)) ? _c('td', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('unitSellingPriceExVat') && _vm.fncInputEx(props.item) == false) ? _c('td', {
          staticClass: "text-xs-right non-input-field min-input-field",
          domProps: {
            "innerHTML": _vm._s(_vm.fncFormatNumber(props.item.price_ex))
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('unitSellingPriceExVat') && _vm.fncInputEx(props.item) == true) ? _c('td', {
          staticClass: "text-xs-right non-input-field min-input-field"
        }, [_c('span', {
          staticStyle: {
            "padding-top": "8px",
            "display": "inline-block",
            "float": "left"
          }
        }, [_vm._v("R")]), _vm._v(" "), _c('v-text-field', {
          staticClass: "popupPrice",
          attrs: {
            "solo": "",
            "single-line": "",
            "type": "number"
          },
          on: {
            "input": function($event) {
              return _vm.fncCanSave(props.index, 'sales')
            }
          },
          model: {
            value: (props.item.price_ex),
            callback: function($$v) {
              _vm.$set(props.item, "price_ex", $$v)
            },
            expression: "props.item.price_ex"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('unitVat')) ? _c('td', {
          staticClass: "text-xs-right non-input-field",
          domProps: {
            "innerHTML": _vm._s(_vm.fncFormatNumber(props.item.vat, props.item.bw_code))
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('unitTotalIncVat')) ? _c('td', {
          staticClass: "text-xs-right non-input-field",
          domProps: {
            "innerHTML": _vm._s(_vm.fncGetUnitTotal(props.item, props.item.bw_code))
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('vendorUnitCostExVat') && _vm.fncInputEx(props.item) == true) ? _c('td', {
          staticClass: "text-xs-right non-input-field min-input-field"
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "disabled": _vm.fncIsDisabledCost(props.item),
            "solo": "",
            "single-line": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncCanSave(props.index, 'cost')
            }
          },
          model: {
            value: (props.item.cost_price),
            callback: function($$v) {
              _vm.$set(props.item, "cost_price", $$v)
            },
            expression: "props.item.cost_price"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('vendorUnitCostExVat') && _vm.fncInputEx(props.item) == false) ? _c('td', {
          staticClass: "text-xs-right non-input-field",
          domProps: {
            "innerHTML": _vm._s(_vm.fncGetCalcCost(props.index, props.item))
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('margin') && _vm.fncInputEx(props.item) == true) ? _c('td', {
          staticClass: "margin-field text-xs-right non-input-field"
        }, [_c('v-text-field', {
          staticStyle: {
            "display": "inline-block",
            "width": "75%",
            "padding-right": "10px"
          },
          attrs: {
            "type": "number",
            "disabled": _vm.fncIsDisabledMargin(props.item),
            "solo": "",
            "single-line": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncCanSave(props.index, 'margin')
            }
          },
          model: {
            value: (props.item.markup),
            callback: function($$v) {
              _vm.$set(props.item, "markup", $$v)
            },
            expression: "props.item.markup"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_vm._v("%")])], 1) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('margin') && _vm.fncInputEx(props.item) == false) ? _c('td', {
          staticClass: "margin-field text-xs-right non-input-field",
          domProps: {
            "innerHTML": _vm._s(_vm.fncGetCalcMargin(props.index, props.item))
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fncShowRow('totalIncVat')) ? _c('td', {
          staticClass: "text-xs-right non-input-field",
          domProps: {
            "innerHTML": _vm._s(_vm.fncGetTotal(props.item, props.item.bw_code))
          }
        }) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "delete-field non-input-field",
          attrs: {
            "width": "5%"
          }
        }, [_c('a', _vm._b({
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteItemRow(props.index, props.item)
            }
          }
        }, 'a', props, false), [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])])])])] : undefined
      }
    }], null, true)
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "margin-top": "1% !important",
      "float": "right",
      "background": "#333",
      "color": "#fff",
      "margin-right": "0% !important"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddRow()
      }
    }
  }, [_vm._v("Add Row")])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('div', {
    staticClass: "specDetails",
    staticStyle: {
      "margin": "1%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncShowSpecDetails(_vm.globalModalParams.details))
    }
  })]), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important",
      "margin-left": "0px"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Street No. and Name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Street No. and Name",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.addressOne),
      callback: function($$v) {
        _vm.addressOne = $$v
      },
      expression: "addressOne"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Complex Name and No.")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Complex Name and No.",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.addressTwo),
      callback: function($$v) {
        _vm.addressTwo = $$v
      },
      expression: "addressTwo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Town")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Town",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.town),
      callback: function($$v) {
        _vm.town = $$v
      },
      expression: "town"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Province")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Province",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.province),
      callback: function($$v) {
        _vm.province = $$v
      },
      expression: "province"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Postal Code")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Postal Code",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.postalCode),
      callback: function($$v) {
        _vm.postalCode = $$v
      },
      expression: "postalCode"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important",
      "margin-left": "0px"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Delivery Special Instructions")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Specific time, directions etc.",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 5,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important",
      "margin-left": "0px"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Account Type")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Customer Account Type",
      "items": _vm.customerAccountTypes,
      "item-value": "name",
      "item-text": "name",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.customerAccountType),
      callback: function($$v) {
        _vm.customerAccountType = $$v
      },
      expression: "customerAccountType"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Account Number")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Customer Account Number",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.customerAccountNumber),
      callback: function($$v) {
        _vm.customerAccountNumber = $$v
      },
      expression: "customerAccountNumber"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isTallisman == true && _vm.spineLoading == false && _vm.activeTab == '0') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncShowSummary())
    }
  }) : _vm._e(), _vm._v(" "), (_vm.spineLoading == false && _vm.showLocationAdd == true) ? _c('div', {
    staticClass: "addLocation"
  }, [_c('div', {
    staticClass: "locationHeading"
  }, [_c('h4', [_vm._v("Create New Location")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "background-color": "#F5F5F5 !important"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showLocationAdd = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "background-color": "#F5F5F5 !important"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSaveLocation()
      }
    }
  }, [_vm._v("Save and Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "locationBody"
  }, [_c('v-text-field', {
    attrs: {
      "solo": ""
    },
    model: {
      value: (_vm.newLocationName),
      callback: function($$v) {
        _vm.newLocationName = $$v
      },
      expression: "newLocationName"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isTallisman == false && _vm.spineLoading == false && _vm.activeTab == '0') ? _c('div', {
    staticClass: "quotePopupTotals",
    staticStyle: {
      "clear": "right"
    }
  }, [_c('table', {
    staticClass: "quotePopupSummary",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none !important",
      "font-size": "14px",
      "border-bottom": "3px double #000 !important",
      "border-top": "1px solid #000 !important"
    }
  }, [_c('strong', [_vm._v("Total (Incl VAT)")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none !important",
      "font-size": "14px",
      "text-align": "right"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncGetFinalTotal())
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "10px",
      "text-align": "right",
      "border": "none !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncGetTotalVat())
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel"), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), (_vm.isDisabled == 'true') ? _c('v-btn', {
    staticClass: "text-xs-right saveandclose",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSaveItems()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v("Save and Close")]) : _vm._e(), _vm._v(" "), (_vm.isDisabled == 'false') ? _c('v-btn', {
    staticClass: "text-xs-right buttonForDisable saveandclose",
    attrs: {
      "disabled": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSaveItems()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v("Save and Close")]) : _vm._e(), _vm._v(" "), (_vm.isLoading == true) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "white"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDisabled == 'true' && _vm.isLoading == false) ? _c('v-btn', {
    staticClass: "text-xs-right saveanddownload",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncPreviewPdf.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("download")]), _vm._v("Save and Download PDF")]) : _vm._e(), _vm._v(" "), (_vm.isDisabled == 'false' && _vm.isLoading == false) ? _c('v-btn', {
    staticClass: "text-xs-right saveanddownload",
    attrs: {
      "disabled": "",
      "true": ""
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("download")]), _vm._v("Save and Download PDF")]) : _vm._e(), _vm._v(" "), (_vm.isDisabled == 'true' && _vm.isLoading == false) ? _c('v-btn', {
    staticClass: "text-xs-right sendtotrolley",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSendToHybrisTrolley.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("trolley")]), _vm._v("Send To Customer Trolley")]) : _vm._e(), _vm._v(" "), (_vm.isDisabled == 'false' && _vm.isLoading == false) ? _c('v-btn', {
    staticClass: "text-xs-right sendtotrolley",
    attrs: {
      "disabled": "true",
      "color": "success"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("trolley")]), _vm._v("Send To Customer Trolley")]) : _vm._e(), _vm._v(" "), (_vm.showSpec == true) ? _c('v-btn', {
    staticClass: "text-xs-right showquote",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideSpec()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("list")]), _vm._v("Show Quote")]) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}